// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .mat-table {
  /* background-color: transparent !important; */
  height: 100%;
  overflow: auto;
  /* display: grid; */
}
:host .mat-header-row {
  top: 0;
  position: sticky;
  z-index: 1;
  padding-left: 10px;
  padding-right: 5px;
}
:host .mat-row {
  padding-left: 10px;
  padding-right: 5px;
}
:host .data-table-header {
  min-height: 0px;
}
:host .data-table-row {
  min-height: 0px;
}
:host .table-toolbar {
  height: 42px;
  display: block;
  line-height: 42px;
}
:host .data-table-paginator {
  height: 42px;
  top: 0px;
  position: absolute;
  right: 0px;
  /* float: right; */
  background-color: transparent;
}
:host .moka-toolbar-editor {
  display: inline-block;
  margin-left: 5px;
  border: 0px;
  height: 28px;
  cursor: pointer;
  vertical-align: middle;
  line-height: 20px;
  box-shadow: 1px 1px 3px -1px #888 !important;
  min-width: 40px;
}
:host .moka-toolbar-select {
  width: 100px;
  line-height: 28px;
  padding-left: 5px;
}
:host .moka-toolbar-button {
  width: 40px;
  padding: unset;
}
:host .table-toolbar .date-range {
  float: left;
  max-height: 42px;
}
:host ::ng-deep .data-table-paginator .mat-paginator-container {
  min-height: unset;
  height: 42px;
}
:host ::ng-deep .data-table-paginator .mat-paginator-container .mat-paginator-page-size {
  height: inherit;
  margin: unset;
}
:host ::ng-deep .data-table-paginator .mat-paginator-container .mat-paginator-page-size-select {
  margin: unset;
}
:host ::ng-deep .dark-theme .mat-select-value {
  color: inherit !important;
}
:host ::ng-deep .mat-select-trigger, :host .mat-select-value {
  color: inherit !important;
}
:host ::ng-deep .left .mat-sort-header-container {
  text-align: left;
  justify-content: left;
}
:host ::ng-deep .center .mat-sort-header-container {
  text-align: center;
  justify-content: center;
}
:host ::ng-deep .right .mat-sort-header-container {
  text-align: right;
  justify-content: right;
}
:host .spinner {
  position: absolute;
  top: 50%;
  left: calc(50% - 20px);
}
:host .small-icon-button {
  width: 24px;
  height: 24px;
  line-height: 24px;
}
:host .small-icon-button .mat-icon {
  width: 20px;
  height: 20px;
  line-height: 20px;
}
:host .small-icon-button .material-icons {
  font-size: 20px;
}
:host .reload-btn {
  position: absolute;
  right: 10px;
  top: 0px;
  z-index: 9999;
}
:host .custom-disabled-button[disabled] {
  color: inherit;
}
:host .custom-disabled-button[disabled] mat-icon {
  color: inherit;
  opacity: 0.2;
}`, "",{"version":3,"sources":["webpack://./src/app/gauges/controls/html-table/data-table/data-table.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/gauges/controls/html-table/data-table/data-table.component.scss"],"names":[],"mappings":"AACI;EACI,8CAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;ACAR;ADGI;EACI,MAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;ACDR;ADII;EACI,kBAAA;EACA,kBAAA;ACFR;ADKI;EACI,eAAA;ACHR;ADMI;EACI,eAAA;ACJR;ADOI;EACI,YAAA;EACA,cAAA;EACA,iBAAA;ACLR;ADQI;EACI,YAAA;EACA,QAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,6BAAA;ACNR;ADSI;EACI,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;EACA,4CAAA;EACA,eAAA;ACPR;ADSI;EACI,YAAA;EACA,iBAAA;EACA,iBAAA;ACPR;ADUI;EACI,WAAA;EACA,cAAA;ACRR;ADWI;EACI,WAAA;EACA,gBAAA;ACTR;ADYI;EACI,iBAAA;EACA,YAAA;ACVR;ADaI;EACI,eAAA;EACA,aAAA;ACXR;ADcI;EACI,aAAA;ACZR;ADeI;EACI,yBAAA;ACbR;ADgBI;EACI,yBAAA;ACdR;ADiBI;EACI,gBAAA;EACA,qBAAA;ACfR;ADkBI;EACI,kBAAA;EACA,uBAAA;AChBR;ADmBI;EACI,iBAAA;EACA,sBAAA;ACjBR;ADoBI;EACI,kBAAA;EACA,QAAA;EACA,sBAAA;AClBR;ADqBI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;ACnBR;ADqBQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;ACnBZ;ADsBQ;EACI,eAAA;ACpBZ;ADwBI;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,aAAA;ACtBR;ADyBI;EACI,cAAA;ACvBR;ADyBQ;EACI,cAAA;EACA,YAAA;ACvBZ","sourcesContent":[":host {\n    ::ng-deep .mat-table {\n        /* background-color: transparent !important; */\n        height: 100%;\n        overflow: auto;\n        /* display: grid; */\n    }\n\n    .mat-header-row {\n        top: 0;\n        position: sticky;\n        z-index: 1;\n        padding-left: 10px;\n        padding-right: 5px;\n    }\n\n    .mat-row {\n        padding-left: 10px;\n        padding-right: 5px;\n    }\n\n    .data-table-header {\n        min-height: 0px;\n    }\n\n    .data-table-row {\n        min-height: 0px;\n    }\n\n    .table-toolbar {\n        height: 42px;\n        display: block;\n        line-height: 42px;\n    }\n\n    .data-table-paginator {\n        height: 42px;\n        top: 0px;\n        position: absolute;\n        right: 0px;\n        /* float: right; */\n        background-color: transparent;\n    }\n\n    .moka-toolbar-editor {\n        display: inline-block;\n        margin-left:5px;\n        border: 0px;\n        height: 28px;\n        cursor: pointer;\n        vertical-align: middle;\n        line-height: 20px;\n        box-shadow: 1px 1px 3px -1px #888 !important;\n        min-width: 40px;\n    }\n    .moka-toolbar-select {\n        width: 100px;\n        line-height: 28px;\n        padding-left: 5px;\n    }\n\n    .moka-toolbar-button {\n        width: 40px;\n        padding: unset;\n    }\n\n    .table-toolbar .date-range {\n        float: left;\n        max-height: 42px;\n    }\n\n    ::ng-deep .data-table-paginator .mat-paginator-container {\n        min-height: unset;\n        height: 42px;\n    }\n\n    ::ng-deep .data-table-paginator .mat-paginator-container .mat-paginator-page-size {\n        height: inherit;\n        margin: unset;\n    }\n\n    ::ng-deep .data-table-paginator .mat-paginator-container .mat-paginator-page-size-select {\n        margin: unset;\n    }\n\n    ::ng-deep .dark-theme .mat-select-value {\n        color: inherit !important;\n    }\n\n    ::ng-deep .mat-select-trigger,.mat-select-value {\n        color: inherit !important;\n    }\n\n    ::ng-deep .left .mat-sort-header-container {\n        text-align: left;\n        justify-content: left;\n    }\n\n    ::ng-deep .center .mat-sort-header-container {\n        text-align: center;\n        justify-content: center;\n    }\n\n    ::ng-deep .right .mat-sort-header-container {\n        text-align: right;\n        justify-content: right;\n    }\n\n    .spinner {\n        position: absolute;\n        top: 50%;\n        left: calc(50% - 20px);\n    }\n\n    .small-icon-button {\n        width: 24px;\n        height: 24px;\n        line-height: 24px;\n\n        .mat-icon {\n            width: 20px;\n            height: 20px;\n            line-height: 20px;\n        }\n\n        .material-icons {\n            font-size: 20px;\n        }\n    }\n\n    .reload-btn {\n        position: absolute;\n        right: 10px;\n        top: 0px;\n        z-index: 9999;\n    }\n\n    .custom-disabled-button[disabled] {\n        color: inherit;\n\n        mat-icon {\n            color: inherit;\n            opacity: 0.2;\n        }\n    }\n}\n",":host ::ng-deep .mat-table {\n  /* background-color: transparent !important; */\n  height: 100%;\n  overflow: auto;\n  /* display: grid; */\n}\n:host .mat-header-row {\n  top: 0;\n  position: sticky;\n  z-index: 1;\n  padding-left: 10px;\n  padding-right: 5px;\n}\n:host .mat-row {\n  padding-left: 10px;\n  padding-right: 5px;\n}\n:host .data-table-header {\n  min-height: 0px;\n}\n:host .data-table-row {\n  min-height: 0px;\n}\n:host .table-toolbar {\n  height: 42px;\n  display: block;\n  line-height: 42px;\n}\n:host .data-table-paginator {\n  height: 42px;\n  top: 0px;\n  position: absolute;\n  right: 0px;\n  /* float: right; */\n  background-color: transparent;\n}\n:host .moka-toolbar-editor {\n  display: inline-block;\n  margin-left: 5px;\n  border: 0px;\n  height: 28px;\n  cursor: pointer;\n  vertical-align: middle;\n  line-height: 20px;\n  box-shadow: 1px 1px 3px -1px #888 !important;\n  min-width: 40px;\n}\n:host .moka-toolbar-select {\n  width: 100px;\n  line-height: 28px;\n  padding-left: 5px;\n}\n:host .moka-toolbar-button {\n  width: 40px;\n  padding: unset;\n}\n:host .table-toolbar .date-range {\n  float: left;\n  max-height: 42px;\n}\n:host ::ng-deep .data-table-paginator .mat-paginator-container {\n  min-height: unset;\n  height: 42px;\n}\n:host ::ng-deep .data-table-paginator .mat-paginator-container .mat-paginator-page-size {\n  height: inherit;\n  margin: unset;\n}\n:host ::ng-deep .data-table-paginator .mat-paginator-container .mat-paginator-page-size-select {\n  margin: unset;\n}\n:host ::ng-deep .dark-theme .mat-select-value {\n  color: inherit !important;\n}\n:host ::ng-deep .mat-select-trigger, :host .mat-select-value {\n  color: inherit !important;\n}\n:host ::ng-deep .left .mat-sort-header-container {\n  text-align: left;\n  justify-content: left;\n}\n:host ::ng-deep .center .mat-sort-header-container {\n  text-align: center;\n  justify-content: center;\n}\n:host ::ng-deep .right .mat-sort-header-container {\n  text-align: right;\n  justify-content: right;\n}\n:host .spinner {\n  position: absolute;\n  top: 50%;\n  left: calc(50% - 20px);\n}\n:host .small-icon-button {\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n}\n:host .small-icon-button .mat-icon {\n  width: 20px;\n  height: 20px;\n  line-height: 20px;\n}\n:host .small-icon-button .material-icons {\n  font-size: 20px;\n}\n:host .reload-btn {\n  position: absolute;\n  right: 10px;\n  top: 0px;\n  z-index: 9999;\n}\n:host .custom-disabled-button[disabled] {\n  color: inherit;\n}\n:host .custom-disabled-button[disabled] mat-icon {\n  color: inherit;\n  opacity: 0.2;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
